<script>
    import AdvancedField from "./AdvancedField.svelte";
    import OPTS from '../../libs/options';
    import { createEventDispatcher } from "svelte";
    import { newAdvTerm } from "../../libs/typefactories";

    const dispatch = createEventDispatcher();
    let advFields = OPTS.advanced_fields.map(it => ({...it, value: ''}));

    function handle() {
        if (!advFields.some(it => it.value !== ''))
            return;

        dispatch('search', advFields.filter(it => it.value !== '').map(it => newAdvTerm(`${it.placeholder}: ${it.value}`, it.name, it.value)))
        advFields.forEach(it => {
            it.value = '';
        })
        advFields = advFields;
    }
</script>
<div id="advanced-filters" class="c-advanced-filters">
    <button class="c-advanced-filters__panel-button c-advanced-filters__panel-button--open">
        <span>Ricerca avanzata</span></button>
    <div class="c-advanced-filters__panel">
        <div class="c-advanced-filters__mobile-button">
            <button id="advanced-filters-close-button"
                    class="c-advanced-filters__panel-button--close">
                <i class="fas fa-chevron-left"></i>
                <span>Ricerca avanzata</span>
            </button>
        </div>
        <div class="c-advanced-filters__panel-body">
            <div class="c-advanced-filters__fields">
                {#each advFields as field}
                    <AdvancedField bind:value={field.value} label={field.placeholder} field={field.name} autocomplete={field.autocomplete} />
                {/each}
            </div>
            <button class="c-advanced-filters__apply-filters" on:click|preventDefault={handle}>Applica filtri</button>
        </div>
    </div>
</div>
